import Entity from '../entity'

export default class Article extends Entity<number> {
    title:string = "";
    showOnHome: boolean = false;
    pictureUrl:string = "";
    short:string = "";
    body:string = '';
    articleCategoryId: number = 0;
    articleCategoryName: string = "";
    creationTime: Date;
}